import colors from './colors';
import spaces from './spaces';

const theme = {
  colors,
  spaces,
};

export default theme;
